import { biLoggerFactory } from 'wix-private';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

const biLogger = biLoggerFactory('lp', 19, { msid: 'ff8ce0a3-44de-43e1-97fb-f47ff24cbc7b' });
const glideOptionsRight = {
    "duration": 450,
    "angle": 270,
    "distance": 70
};

const glideOptionsLeft = {
    "duration": 450,
    "angle": 90,
    "distance": 70
};

const fadeOptions = {
    "duration": 100
};

const buttons = {
    //desktop
    startNow: "Start Now",
    viewProject: 'View Project',
    webinar: "Join our Webinar",
    visitSite: 'Visit Site',
    exploreAgency: 'Explore Agency',
    JOPProgram: 'Join Our Partners Program',
    learnMore: 'Learn More',
    getCertified: 'Get certified',
    //mobile
    letsTalk: "Let's Talk"
}
const additionalInfo = {
    //desktop
    topFold: 'Corvid tab top fold',
    advancedCapabilities: 'Corvid tab, Tailor made solutions fold - Advanced capabilities',
    customizeElements: 'Corvid tab, Tailor made solutions fold - Customize elements',
    ThirdPartyServices: 'Corvid tab, Tailor made solutions fold - 3rd party services',
    CFADPages: 'Corvid tab, Tailor made solutions fold - Custom forms & dynamic pages',
    basicInfo: 'Corvid tab, Tailor made solutions fold',
    EBFold: 'Corvid tab, Exclusive benefits fold',
    CCFold: 'Corvid tab, Corvid-certified fold',
    bottomFold: 'Corvid tab, Bottom fold',
    //mobile
    topFoldMobile: 'Corvid tab top fold, mobile',
    basicInfoMobile: 'Corvid tab, Tailor made solutions fold, mobile',
    EBFoldMobile: 'Corvid tab, Exclusive benefits fold, mobile',
}

const deviceType = wixWindow.formFactor

let checkIfAnimationOn = true

$w.onReady(function () {

    let myVar = setInterval(myTimer, 8000);

    function myTimer() {

        if (deviceType === "Desktop") {
            if (checkIfAnimationOn) {
                toggleFront()

            }

            setTimeout(function () {
                if (checkIfAnimationOn) {
                    toggleBack()

                }
            }, 4000);
        }

    }

    $w("#boxToggleDark").onMouseIn((event) => {
        checkIfAnimationOn = false
        clearInterval(myVar);

    });

    $w("#boxToggleBright").onMouseIn((event) => {
        checkIfAnimationOn = false
        clearInterval(myVar);

    });

    //

    $w("#boxToggleDark").onMouseOut((event) => {
        checkIfAnimationOn = true
        myVar = setInterval(myTimer, 8000);

    });

    $w("#boxToggleDark").onMouseOut((event) => {
        checkIfAnimationOn = true
        myVar = setInterval(myTimer, 8000);

    });

    initPageEvents();
})

function initPageEvents() {
    $w('#brightButtonWhiteLeft').onClick(toggleFront);
    $w('#darkButtonGreenRight').onClick(toggleFront);
    $w('#darkButtonWhiteLeft').onClick(toggleBack);
    $w('#brightButtonGreenRight').onClick(toggleBack);
    $w('#brightButtonWhiteLeftNeg').onClick(toggleFront);
    $w('#darkButtonGreenRightNeg').onClick(toggleFront);
    $w('#darkButtonWhiteLeftNeg').onClick(toggleBack);
    $w('#brightButtonGreenRightNeg').onClick(toggleBack);
    //BI events
    $w('#box253').onClick(() => {
        fireBIEvent(buttons.startNow, additionalInfo.topFold);
    })
    $w('#box254').onClick(() => {
        fireBIEvent(buttons.webinar, additionalInfo.topFold);
    })
    $w('#box245').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.advancedCapabilities);
    })
    $w('#box247').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.customizeElements);
    })
    $w('#box249').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.ThirdPartyServices);
    })
    $w('#box251').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.CFADPages);
    })
    $w('#box224').onClick(() => {
        fireBIEvent(buttons.startNow, additionalInfo.basicInfo);
    })
    $w('#box255').onClick(() => {
        fireBIEvent(buttons.JOPProgram, additionalInfo.EBFold);
    })
    $w('#box259').onClick(() => {
        fireBIEvent(buttons.learnMore, additionalInfo.EBFold);
    })
    $w('#box261').onClick(() => {
        fireBIEvent(buttons.learnMore, additionalInfo.EBFold);
    })
    $w('#box178').onClick(() => {
        fireBIEvent(buttons.getCertified, additionalInfo.CCFold);
    })
    $w('#box262').onClick(() => {
        fireBIEvent(buttons.getCertified, additionalInfo.CCFold);
    }) //mobile
    $w('#box243').onClick(() => {
        fireBIEvent(buttons.startNow, additionalInfo.bottomFold);
    })
    $w('#imageX19').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.advancedCapabilities);
        wixWindow.openLightbox("Harasat");
    })
    $w('#imageX18').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.customizeElements);
        wixWindow.openLightbox("Hamilton");
    })
    $w('#imageX17').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.ThirdPartyServices);
        wixWindow.openLightbox("Brynk");
    })
    $w('#imageX16').onClick(() => {
        fireBIEvent(buttons.viewProject, additionalInfo.CFADPages);
        wixWindow.openLightbox("LawExchange");
    })

    $w('#box257').onClick(() => {
        fireBIEvent(buttons.letsTalk, additionalInfo.topFoldMobile);
    })
    $w('#box223').onClick(() => {
        fireBIEvent(buttons.letsTalk, additionalInfo.basicInfoMobile);
    })
    $w('#box260').onClick(() => {
        fireBIEvent(buttons.letsTalk, additionalInfo.EBFoldMobile);
    })
    $w('#box263').onClick(() => {
        fireBIEvent(buttons.letsTalk, additionalInfo.bottomFold);
    })

}

function toggleFront() {

    setTimeout(function () {
        $w('#imageBright').hide();
        $w('#imageDark').show();
    }, 250);

    // $w('#boxToggleDark').show();
    // $w('#boxToggleBright').hide();

    // $w('#selectTextW').show();
    // $w('#selectTextG').hide();

    // $w('#boxToggle').style.backgroundColor = "#1C7962";
    // $w('#selectText').html = `<h6 style="color: #fff">Select mode</h6>`

    $w('#brightButtonWhiteLeft').hide("fade", fadeOptions);
    $w('#darkButtonWhiteLeft').show();
    $w('#darkButtonGreenRight').hide("fade", fadeOptions);
    $w('#brightButtonGreenRight').show("glide", glideOptionsRight);

    $w('#brightButtonWhiteLeftNeg').hide("fade", fadeOptions);
    $w('#darkButtonWhiteLeftNeg').show();
    $w('#darkButtonGreenRightNeg').hide("fade", fadeOptions);
    $w('#brightButtonGreenRightNeg').show("glide", glideOptionsRight);
}

function toggleBack() {

    setTimeout(function () {
        $w('#imageBright').show();
        $w('#imageDark').hide();
    }, 250);

    // $w('#boxToggleDark').hide();
    // $w('#boxToggleBright').show();

    // $w('#selectTextW').hide();
    // $w('#selectTextG').show();

    // $w('#boxToggle').style.backgroundColor = "#e8e8e8";
    // $w('#selectText').html = `<h6 style="color: #1C7962">Select mode</h6>`

    $w('#darkButtonWhiteLeft').hide();
    $w('#brightButtonWhiteLeft').show("glide", glideOptionsLeft);
    $w('#brightButtonGreenRight').hide("fade", fadeOptions);
    $w('#darkButtonGreenRight').show();

    $w('#darkButtonWhiteLeftNeg').hide();
    $w('#brightButtonWhiteLeftNeg').show("glide", glideOptionsLeft);
    $w('#brightButtonGreenRightNeg').hide("fade", fadeOptions);
    $w('#darkButtonGreenRightNeg').show();
}

export async function fireBIEvent(button, info) {
    const biEventObject = {
        evid: 703,
        button_name: button,
        topic: 'partners site',
        additional_info: info,
        is_valid: true,
        url: wixLocation.url
    };
    await biLogger.log(biEventObject);
    console.log("done")
}